<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6">
        <h6>{{ stepTitle }}</h6>
      </div>
      <div class="col-md-6" *ngIf="siteId !== ''">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="formData" #formDirective="ngForm" novalidate>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Contracted Demand (KVA)
            <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              type="number"
              [(ngModel)]="model.contractedDemand"
              matInput
              placeholder="Contracted Demand (KVA)"
              formControlName="contractedDemandCtr"
              required
            />
            <mat-error
              *ngIf="isFieldHasError('contractedDemandCtr', 'required')"
              >This field is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Connected Load (KW) <span class="iep-required">*</span>
          </mat-label>
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              type="number"
              [(ngModel)]="model.connectLoad"
              matInput
              placeholder="Connected Load (KW)"
              formControlName="connectLoadCtr"
              required
            />
            <mat-error *ngIf="isFieldHasError('connectLoadCtr', 'required')"
              >This field is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Peak Recorded Demand (KW) <span class="iep-required">*</span>
          </mat-label>
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              type="number"
              [(ngModel)]="model.peakRecordedDemand"
              matInput
              placeholder="Peak Recorded Demand (KW)"
              formControlName="peakRecordedDemandCtr"
              required
            />
            <mat-error
              *ngIf="isFieldHasError('peakRecordedDemandCtr', 'required')"
              >This field is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >3 Months Average demand (KW)</mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              type="text"
              [(ngModel)]="model.threeMnthsAvgDemand"
              matInput
              placeholder="3 Months Average demand (KW)"
              formControlName="threeMnthsAvgDemandCtr"
            />
            <mat-error
              *ngIf="isFieldHasError('threeMnthsAvgDemandCtr', 'pattern')"
            >
              Only numbers are allowed.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right">Line type</mat-label>
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Choose Line Type</mat-label>
            <mat-select
              [(ngModel)]="model.lineType"
              formControlName="lineTypeCtr"
            >
              <mat-option>Choose Line Type</mat-option>
              <mat-option value="11 kV Feeder">11 kV Feeder</mat-option>
              <mat-option value="33 kV Feeder">33 kV Feeder</mat-option>
              <mat-option value="66 kV Feeder">66 kV Feeder</mat-option>
              <mat-option value="110 kV Feeder">110 kV Feeder</mat-option>
              <mat-option value="440 V">440 V</mat-option>
              <mat-option value="220 V">220 V</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right">DiscomZone</mat-label>
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              [(ngModel)]="model.discomZone"
              matInput
              placeholder="DiscomZone"
              formControlName="discomZoneCtr"
            />
            <mat-error *ngIf="isFieldHasError('discomZoneCtr', 'whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >ToU Tariff Structure <span class="iep-required">*</span>
          </mat-label>
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Select</mat-label>
            <mat-select
              [(ngModel)]="model.tou"
              formControlName="touCtr"
              (ngModelChange)="changeToU()"
            >
              <mat-option>Select</mat-option>
              <mat-option value="yes">Yes</mat-option>
              <mat-option value="no">No</mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldHasError('touCtr', 'required')"
              >Please select an item in the list.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right">CO2 Factor</mat-label>
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              type="number"
              [(ngModel)]="model.co2Factor"
              matInput
              placeholder="CO2 factor"
              formControlName="co2FactorCtr"
              step="0.1"
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="model.tou === 'no'">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Enter KVA Tariff <span class="iep-required">*</span>
          </mat-label>
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <input
              type="number"
              [(ngModel)]="model.kvaTariff"
              matInput
              placeholder="Enter KVA Tarrif"
              formControlName="kvaTariffCtr"
              step="0.01"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="model.tou === 'yes'">
      <div class="col-md-12">
        <div class="col-md-2"></div>
        <div class="col-md-10">
          <table class="table-responsive">
            <caption></caption>
            <thead>
              <tr>
                <th scope="col">
                  'From' Time <span class="iep-required">*</span>
                </th>
                <th scope="col">'To' Time</th>
                <th scope="col">Rate <span class="iep-required">*</span></th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let slab of model.slabs; let rIndex = index">
                <td>
                  <mat-form-field>
                    <input
                      matInput
                      type="time"
                      formControlName="startTimeValueCtr_{{
                        formControlIndex[rIndex]
                      }}"
                      (change)="onStartTimeChanged($event, rIndex)"
                      [(ngModel)]="slab.startTime"
                      [value]="slab.startTime"
                      placeholder="HH:mm:ss"
                      required
                    />
                    <mat-error
                      *ngIf="
                        isFieldHasError(
                          'startTimeValueCtr_' + formControlIndex[rIndex],
                          'required'
                        )
                      "
                    >
                      This field is required.</mat-error
                    >
                    <mat-error
                      *ngIf="
                        isFieldHasError(
                          'startTimeValueCtr_' + formControlIndex[rIndex],
                          'dateRangeInvalid'
                        )
                      "
                    >
                      From Time must be less than To Time</mat-error
                    >
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field>
                    <input
                      matInput
                      type="time"
                      formControlName="endTimeValueCtr_{{
                        formControlIndex[rIndex]
                      }}"
                      [value]="slab.endTime"
                      [(ngModel)]="slab.endTime"
                      (change)="onEndTimeChanged($event, rIndex)"
                      placeholder="HH:mm:ss"
                      required
                    />
                    <mat-error
                      *ngIf="
                        isFieldHasError(
                          'endTimeValueCtr_' + formControlIndex[rIndex],
                          'required'
                        )
                      "
                    >
                      This field is required.</mat-error
                    >
                    <mat-error
                      *ngIf="
                        isFieldHasError(
                          'endTimeValueCtr_' + formControlIndex[rIndex],
                          'dateRangeInvalid'
                        )
                      "
                    >
                      From Time must be greater than To Time</mat-error
                    >
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field>
                    <input
                      matInput
                      type="number"
                      step="0.01"
                      formControlName="rateValueCtr_{{
                        formControlIndex[rIndex]
                      }}"
                      placeholder="Rs/KWh"
                      required
                      [value]="slab.rate"
                      [(ngModel)]="slab.rate"
                    />
                    <mat-error
                      *ngIf="
                        isFieldHasError(
                          'rateValueCtr_' + formControlIndex[rIndex],
                          'required'
                        )
                      "
                    >
                      This field is required.</mat-error
                    >
                  </mat-form-field>
                </td>
                <td style="width: 30%">
                  <button
                    id="clearbtn_{{ rIndex }}"
                    class="mat-raised-button"
                    (click)="clear(rIndex)"
                    style="
                      margin-left: 1em;
                      line-height: 55px;
                      margin-top: -5px;
                    "
                  >
                    Clear
                  </button>
                  <button
                    id="removebtn_{{ rIndex }}"
                    class="mat-raised-button"
                    (click)="remove($event, rIndex)"
                    *ngIf="model.slabs.length > 1"
                    style="
                      margin-left: 1em;
                      line-height: 55px;
                      margin-top: -5px;
                    "
                  >
                    Remove
                  </button>
                  <button
                    id="addbtn_{{ rIndex }}"
                    class="mat-raised-button"
                    (click)="add()"
                    *ngIf="
                      model.slabs.length < maxNumberOfSlabs &&
                      rIndex === model.slabs.length - 1
                    "
                    style="
                      margin-left: 1em;
                      line-height: 55px;
                      margin-top: -5px;
                    "
                  >
                    Add
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        *ngIf="isOverlapSlabTime"
        class="col-xs-5 col-sm-5 col-md-5 col-lg-5"
      >
        <div
          class="alert alert-danger alert-normal-danger"
          *ngIf="isOverlapSlabTime"
        >
          Time shifts overlapping!
        </div>
      </div>
      <div class="col-md-12" style="text-align: center">
        <button
          id="previousbtn"
          bciprimarybutton
          class="button-primary"
          (click)="goPrevious($event)"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-arrow-left-frame"
              style="width: max-content"
            ></mat-icon> </span
          >Previous
        </button>
        &nbsp;
        <button
          id="savebtn"
          bciprimarybutton
          class="button-primary"
          type="submit"
          (click)="submit()"
          [disabled]="!formData.valid || !formData.dirty || isOverlapSlabTime"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-checkmark-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
          Save
        </button>
        &nbsp;
        <button
          id="nextbtn"
          bciprimarybutton
          class="button-primary"
          (click)="goTo($event)"
        >
          Next
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-arrow-right-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
        </button>
      </div>
    </div>
  </form>
</mat-expansion-panel>
